import React, { FC } from "react";

import { TheCycleverseTheme } from "src/theme";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    maxWidth: theme.widths.calculatorWidth,
    overflow: "hidden",
  },
  img: {
    maxWidth: "100%",
    height: "auto",
    verticalAlign: "middle",
  },
}));

export const CalculatorImage = (props) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, props.classMain)}>
      <img alt="Logo" className={classes.img} {...props} />
    </div>
  );
};
